export const CertificatesOptions = [
    { label:"Student Email", value: "email" },
]